import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { Link } from "react-router-dom";

import {
    getCngDryerInletPressure,
    getInletGasFlowRate250
} from "../../constants/sizing-constant";

export default class DryerGasCNGSizing extends Component {
    state = {
        inletCNGPressure: [],
        selectedInletCNGPressure: "0",

        inletGasFlowRate: [],
        selectedInletGasFlowRate: "0",

        suggestedModel: "",
        suggestedModelId: "",
        suggestedModelPower: "",
        suggestedModelMeshSize:"",
        sentrifuge: []
    };

    componentDidMount() {
        this.setState({ inletCNGPressure: [...getCngDryerInletPressure()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handleInletCNGPressureSelect = inletCNGPressure => {
        if (inletCNGPressure) {
            this.setState({ selectedInletCNGPressure: inletCNGPressure.value }, () => { });
            this.setState({ suggestedModel: "" }, () => { });
            if (inletCNGPressure.value === "1")
            {
                this.setState({ suggestedModel: "HCD Type 500/60" });
                this.setState({ suggestedModelId: "124" });
                this.setState({ suggestedModelPower: "22" });
                this.setState({ suggestedModelMeshSize: "۱" });
            }
            if (inletCNGPressure.value === "2")
                this.setState({ inletGasFlowRate: [...getInletGasFlowRate250()] });
        }
    };

    handleInletGasFlowRateSelect = inletGasFlowRate => {
        if (inletGasFlowRate) {
            this.setState({ selectedInletGasFlowRate: inletGasFlowRate.value }, () => {
                this.findModel();
            });
        }
    };

    findModel() {
        const selectedInletCNGPressure = this.state.selectedInletCNGPressure;
        const selectedInletGasFlowRate = this.state.selectedInletGasFlowRate;
        if (selectedInletCNGPressure === "2") {
           if (selectedInletGasFlowRate === "1") {
               this.setState({ suggestedModel: "HCD Type 500/250" });
               this.setState({ suggestedModelId: "125" });
               this.setState({ suggestedModelPower: "22" });
               this.setState({ suggestedModelMeshSize: "۱۰" });
           }
           else if (selectedInletGasFlowRate === "2") {
               this.setState({ suggestedModel: "HCD Type 1200/250" });
               this.setState({ suggestedModelId: "126" });
               this.setState({ suggestedModelPower: "32" });
               this.setState({ suggestedModelMeshSize: "۱۰" });
           }
           else if (selectedInletGasFlowRate === "3") {
               this.setState({ suggestedModel: "HCD Type 1500/250" });
               this.setState({ suggestedModelId: "127" });
               this.setState({ suggestedModelPower: "116.5" });
               this.setState({ suggestedModelMeshSize: "۱۰" });
           }
        }
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.inletCNGPressure}
                    placeholder="فشار ورودی (برحسب psi - g)"
                    onItemSelect={this.handleInletCNGPressureSelect}
                />
                {this.state.selectedInletCNGPressure === "2" &&
                    <DropDownWhiteStyle
                    items={this.state.inletGasFlowRate}
                        placeholder="ظرفیت بر حسب نرمال متر مکعب"
                    onItemSelect={this.handleInletGasFlowRateSelect}
                    />
                }
                {this.state.suggestedModel !== "" &&
                    <Fragment>
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <h3 className="text-title-description">فشار خروجی کمپرسور : ۲۲۵ Bar g</h3>
                        <h3 className="text-title-description">قدرت موتور : {this.state.suggestedModelPower} (kw)</h3>
                        <h3 className="text-title-description">Dew Point : - 60° C</h3>
                        <h3 className="text-title-subHeader">مشخصات Blower-Heater-Air cooler</h3>
                        <h3 className="text-title-description">Phase : 3</h3>
                        <h3 className="text-title-description">Voltage : 380 V</h3>
                        <h3 className="text-title-description">Frequency : 50 Hz</h3>
                        <h3 className="text-title-subHeader">مشخصات فیلتر</h3>
                        <h3 className="text-title-description">Pre Filter Mesh size : {this.state.suggestedModelMeshSize} (microns)</h3>
                        <h3 className="text-title-description">After Filter Mesh size : {this.state.suggestedModelMeshSize} (microns)</h3>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
